import { render } from "./TarificationSection.vue?vue&type=template&id=16051091"
import script from "./TarificationSection.vue?vue&type=script&lang=js"
export * from "./TarificationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__